export default __webpack_public_path__ + "static/media/MYR.39efad55.svg";